// Per-task checklist API wrappers (tasks-clickup-overhaul P2).
// The TaskModal's ChecklistSection manages its own local list state.

import { api } from "../lib/api";
import type { TaskChecklistItem } from "@juuplan/shared";

export function fetchChecklist(taskId: number): Promise<TaskChecklistItem[]> {
  return api<TaskChecklistItem[]>(`/api/tasks/${taskId}/checklist`);
}

export function addChecklistItem(taskId: number, title: string): Promise<TaskChecklistItem> {
  return api<TaskChecklistItem>(`/api/tasks/${taskId}/checklist`, { method: "POST", body: { title } });
}

export function patchChecklistItem(
  taskId: number,
  itemId: number,
  patch: { title?: string; is_done?: boolean; sort_order?: number }
): Promise<TaskChecklistItem> {
  return api<TaskChecklistItem>(`/api/tasks/${taskId}/checklist/${itemId}`, { method: "PATCH", body: patch });
}

export function deleteChecklistItem(taskId: number, itemId: number): Promise<void> {
  return api(`/api/tasks/${taskId}/checklist/${itemId}`, { method: "DELETE" }) as unknown as Promise<void>;
}
